import React from 'react';

class TriangleToggle extends React.PureComponent {
    render() {
        const { size, style } = this.props;

        return (
            <div
                style={{
                    display: 'inline-block',
                    width: 0,
                    height: 0,
                    borderBottom: `calc( ${size}px * 1.732 ) solid`,
                    borderLeft: `${size}px solid transparent`,
                    borderRight: `${size}px solid transparent`,
                    transform: 'rotate(90deg)',
                    ...style,
                }}
            />
        );
    }
}

TriangleToggle.defaultProps = {
    size: 5,
};

export default TriangleToggle;
